@switch (serviceType) {
    @case (ServiceType.VIDEO_ADS) {
        Oświadczam, że zapoznałem/am się i akceptuję
        <a
            href="https://panel.onetads.pl/static/video-ads/regulamin.pdf"
            target="_blank"
        >Regulamin Usługi Reklama Wideo</a>.
    }
    @case (ServiceType.RETAIL_MEDIA) {
        Oświadczam, że zapoznałem/am się i akceptuję
        <a
            href="https://panel.onetads.pl/static/rmn/regulamin-retail-media-network-dla-reklamodawcow.pdf"
            target="_blank"
        >Regulamin Retail Media Network dla reklamodawców</a>.
    }
    @case (ServiceType.SKAPIEC) {
        Oświadczam, że zapoznałem/am się i akceptuję <a
            [href]="SKAPIEC_AGREEMENT_URL"
            target="_blank"
        >Regulamin Współpracy z Serwisem Skąpiec</a> oraz pełną treść Cennika.
    }
    @case (ServiceType.LAMODA) {
        Oświadczam, że zapoznałem/am się i akceptuję <a
            href="https://panel.onetads.pl/static/lamoda/regulamin.pdf"
            target="_blank"
        >Regulamin Współpracy z Serwisem LaModa</a>.
    }
    @case (ServiceType.MAILING) {
        Oświadczam, że zapoznałem/am się i akceptuję <a
            href="https://panel.onetads.pl/static/mailing/regulamin-uslugi-mailing.pdf"
            target="_blank"
        >Regulamin Współpracy z Serwisem Mailing</a>.
    }
    @case (ServiceType.MAILING_INBOX) {
        Oświadczam, że zapoznałem/am się i akceptuję <a
            href="https://panel.onetads.pl/static/mailing-inbox/regulamin-uslugi-poczta-inbox.pdf"
            target="_blank"
        >Regulamin Współpracy z Serwisem Poczta Inbox</a>.
    }
    @case (ServiceType.MAILING_RETARGETING) {
        Oświadczam, że zapoznałem/am się i akceptuję <a
            href="https://panel.onetads.pl/static/mailing/regulamin-uslugi-mailing.pdf"
            target="_blank"
            rel="noopener noreferrer"
        >Regulamin usługi Mailing e-commerce</a>.
    }
    @default {
        Akceptuję regulamin
    }
}
